import { createBrowserRouter, Navigate } from "react-router-dom";
import { Inbox, Main, Public } from "~/layouts";
import { Admin } from "~/layouts/Admin";
import NotFound from "~/routes/not-found";
import Management from "~/routes/management";
import Tasks from "~/routes/tasks";
import Kanban from "~/routes/kanban";
import SignUp from "~/routes/sign-up";
import SignIn from "~/routes/sign-in";
import Chat from "~/routes/chat";
import InboxRoot from "~/routes/inbox-root";

const router = createBrowserRouter([
    {
        path: "/me",
        element: <Main />,
        children: [
            {
                path: "a", // @TODO: rename
                element: <Admin />,
                children: [
                    {
                        path: "manage/:tab?",
                        element: <Management />,
                    },
                ],
            },
            {
                path: "kanban",
                element: <Kanban />,
            },
            {
                path: "tasks",
                element: <Tasks />,
            },
            {
                path: "milestones",
                element: <>Milestones</>,
            },
            {
                path: "overview",
                element: <>Overview</>,
            },
            {
                path: "inbox",
                element: <Inbox />,
                children: [
                    {
                        index: true,
                        element: <InboxRoot />,
                    },
                    {
                        path: ":id",
                        element: <Chat />,
                    },
                ],
            },
        ],
    },
    {
        path: "p",
        element: <Public />,
        children: [
            {
                path: "sign-up",
                element: <SignUp />,
            },
            {
                path: "sign-in",
                element: <SignIn />,
            },
        ],
    },
    {
        path: "/",
        element: <Navigate to="/me" replace />,
    },
    {
        path: "*",
        element: <NotFound />,
    },
]);

export default router;
